import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { GetOrderUpdateUserExtraInfoRequestType } from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseGetOrderUpdateUserExtraInfoResponseInterface {
  updateUserExtraInfoApi: UseMutateAsyncFunction<
    {},
    unknown,
    { orderId: string; values: any },
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useUpdateUserExtraInfoDetails =
  (): UseGetOrderUpdateUserExtraInfoResponseInterface => {
    const { paymentServices } = usePaymentServices();

    const updateUserExtraInfo = (data) => {
      const { orderId, values } = data;
      const { email, ...rest } = values;

      const extraInfo = {
        email: email
      };

      const requestObject: GetOrderUpdateUserExtraInfoRequestType = {
        order_id: orderId,
        user_extra_info: JSON.stringify(extraInfo),
        extra_info_based_on_product_config: JSON.stringify({ ...rest })
      };

      return paymentServices.updateUserExtraInfo(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(updateUserExtraInfo, {
      mutationKey: ['updateUserExtraInfoApi']
    });

    const updateUserExtraInfoApi = mutateAsync;

    return {
      updateUserExtraInfoApi,
      error: error ? getAPIErrorMessage(error) : '',
      status
    };
  };

export { useUpdateUserExtraInfoDetails };
